import {
    ICasoCobrancaFilaAtendimentoPorGrupoProcedure,
    IContatosDaFilaAtendimento,
    IFilaAtendimento,
    IProdutoCaso,
} from "../../../Interfaces/Cobranca/FilaAtendimento/FilaAtendimentoInterface";
import { IAcoesReguaEtapa } from "../../../Interfaces/Automacao/Regua/GestaoDeRegua/GestaoDeReguaInterfaces";
import Axios from "../../Config/API";
import Service from "../../Service";

type TGestaoFilaAtendimentoResponse =
    | Array<ICasoCobrancaFilaAtendimentoPorGrupoProcedure>
    | Blob;

export async function CarregarDistribuicaoService() {
    return Service(
        Axios.get<Array<IFilaAtendimento>>(
            `/cobranca/filaatendimentos/carregardistribuicaofilaatendimento`
        )
    );
}

export async function GetProximoAtendimentoService(
    idGrupo: number,
    idCampanha: number
) {
    return Service(
        Axios.get<number>(
            `/cobranca/filaatendimentos/getmodoatendimento?ID_GRUPO=${idGrupo}&ID_CAMPANHA=${idCampanha}`
        )
    );
}

export async function ListarCasoCobrancaFilaAtendimentoPorGrupoService(
    idGrupo: number,
    idCampanha: number,
    exportExcel?: number
) {
    return Service(
        Axios.get<TGestaoFilaAtendimentoResponse>(
            `/cobranca/filaatendimentos/listarcasocobrancafilaatendimentoporgrupo?idGrupo=${idGrupo}&idCampanha=${idCampanha}&exportExcel=${exportExcel}`,
            { responseType: exportExcel === 1 ? "blob" : "json" }
        )
    );
}

export async function ListarCasoCobrancaFilaAtendimentoDetalhadoPorGrupoService(
    idGrupo: number,
    idCampanha: number
) {
    return Service(
        Axios.get<IContatosDaFilaAtendimento>(
            `/cobranca/filaatendimentos/listarcasocobrancafilaatendimentodetalhadaporgrupo?idGrupo=${idGrupo}&idCampanha=${idCampanha}`
        )
    );
}

export async function GetCasoCobrancaFilaAtendimentoPorGrupoService(
    idGrupo: number,
    idCampanha: number
) {
    return Service(
        Axios.get<IFilaAtendimento>(
            `/cobranca/filaatendimentos/getdistribuicaofilaatendimento?ID_GRUPO=${idGrupo}&ID_CAMPANHA=${idCampanha}`
        )
    );
}

export async function GetAcaoFilaServices(idGrupo: number) {
    return Service(
        Axios.get<IAcoesReguaEtapa>(
            `/cobranca/filaatendimentos/getacaofila?idGrupo=${idGrupo}`
        )
    );
}

export async function ListarProdutosEmAtendimentoDeFilaService(
    ID_CASO: number
) {
    return Service(
        Axios.get<Array<IProdutoCaso>>(
            `/cobranca/filaatendimentos/listarprodutosematendimentodefila?ID_CASO=${ID_CASO}`
        )
    );
}
